import type { ReactNode } from 'react';
import React from 'react';

import { Outlet } from 'react-router-dom';

import { CustomAlertBaseErrorBoundary } from './error/custom-alert-base-error-boundary';
import { NotFoundPage } from './error/not-found';
import { UnavailablePage } from './error/unavailable';

export const CustomAlertBase = () => {
  return (
    <CustomAlertBaseErrorBoundary
      fallback={<UnavailablePage />}
      notFoundFallback={<NotFoundPage />}
    >
      <Outlet />
    </CustomAlertBaseErrorBoundary>
  );
};
